import { render, staticRenderFns } from "./TheExportChatModal.vue?vue&type=template&id=f0bf550c&scoped=true"
import script from "./TheExportChatModal.vue?vue&type=script&lang=js"
export * from "./TheExportChatModal.vue?vue&type=script&lang=js"
import style0 from "./TheExportChatModal.vue?vue&type=style&index=0&id=f0bf550c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf550c",
  null
  
)

export default component.exports